module.exports = __webpack_public_path__ + "static/media/chevron-up-contrast.a88392d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-up-contrast.svg
// module id = 247
// module chunks = 0